import * as React from 'react'
import loadable from '@loadable/component'

import { AutocompletePrediction, i18n } from '@thg-commerce/enterprise-core'
import { spacing, styled } from '@thg-commerce/gravity-theme'

const UseMyLocation = loadable(
  () => import('@thg-commerce/gravity-icons/src/components/UseMyLocation'),
)

interface AutocompletePredictionsProps {
  setSearchInputOverride: React.Dispatch<React.SetStateAction<string>>
  setAutocompletePredictions: React.Dispatch<
    React.SetStateAction<AutocompletePrediction[]>
  >
  setShowGeolocation: React.Dispatch<React.SetStateAction<boolean>>
  getUserLocation: () => void
  showGeolocation: boolean
  predictions: AutocompletePrediction[]
}

const DropdownItem = styled.li`
  cursor: pointer;
  width: 100%;
  padding: ${spacing(2)} 0 ${spacing(2)} ${spacing(3)};
  margin: 0;
  background-color: ${(props) => props.theme.colors.palette.greys.white};
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.15);

  &:first-child {
    border-top: ${spacing(1)} solid
      ${(props) => props.theme.colors.palette.greys.lighter};
  }

  &:last-child {
    border-bottom: ${spacing(1)} solid
      ${(props) => props.theme.colors.palette.greys.lighter};
  }

  &:hover,
  &:active {
    background-color: ${(props) => props.theme.colors.palette.greys.lighter};
  }

  &:focus-within {
    border-color: ${(props) => props.theme.colors.palette.brand.base};
  }
`

export const AutocompletePredictions = (
  props: AutocompletePredictionsProps,
) => {
  const i18nText = i18n('storelocator.storesearch.usemylocation')

  return (
    <ul
      data-testid="autocomplete-suggestions"
      style={{
        width: '100%',
        position: 'absolute',
        zIndex: 1,
      }}
    >
      {props.showGeolocation && (
        <DropdownItem onClick={props.getUserLocation}>
          <UseMyLocation
            style={{ marginRight: spacing(2.25), verticalAlign: 'top' }}
          />
          {i18nText}
        </DropdownItem>
      )}
      {props.predictions && props.predictions.length > 0
        ? props.predictions.map((prediction: AutocompletePrediction, index) => {
            return (
              <DropdownItem
                key={index}
                value={prediction.description}
                onClick={() => {
                  props.setSearchInputOverride(prediction.description)
                  props.setAutocompletePredictions([])
                  props.setShowGeolocation(false)
                }}
              >
                {prediction.description}
              </DropdownItem>
            )
          })
        : null}
    </ul>
  )
}
